import { RouteLocation } from 'vue-router'
import { Route } from '@/router/types'

export const sopLibraryRoute = (): Route => ({
  path: '/tools/library',
  name: '#sopLibrary',
  component: () => import('@/pages/Tools/SopLibrary/SopLibrary.vue'),
  meta: {
    title: 'SOP Library',
    permissionCheck: 'canViewCareTeamDocViewer',
  },
})
export const sopLibraryDocumentRoute = (): Route => ({
  // Display name is optional and doesn't affect routing
  path: '/tools/library/:documentId/:displayName?',
  props: (route: RouteLocation) => ({
    documentId: route.params.documentId,
    displayName: route.params.displayName,
    search: route.query.search,
  }),
  name: '#sopLibraryDocument',
  component: () =>
    import(
      '@/pages/Tools/SopLibrary/SopLibraryDocument/SopLibraryDocument.vue'
    ),
  meta: {
    title: 'Care Team Document',
    permissionCheck: null,
  },
})

export const toolRoutes: Route[] = [
  {
    path: '/tools/unknown-texts',
    name: '#unknownTexts',
    component: () => import('@/legacy/pages/UnknownTextsPage.vue'),
    meta: {
      title: 'Unknown Texts',
      permissionCheck: 'canViewPageUnknownTexts',
    },
  },
  {
    path: '/tools/fax-management/:tab?/:faxId?',
    name: '#faxManagement',
    component: () =>
      import(
        '@/pages/Tools/FaxManagement/FaxManagementPage/FaxManagementPage.vue'
      ),
    props: (route) => ({
      tab: route.params.tab ?? 'inbound',
      faxId: route.params.faxId,
    }),
    meta: {
      title: 'Fax Management',
      permissionCheck: 'canViewPageInboundFaxes',
    },
  },
  {
    path: '/tools/provider-callbacks',
    name: '#providerCallbacks',
    component: () =>
      import('@/pages/Tools/ProviderCallbacks/ProviderCallbacksPage.vue'),
    meta: {
      title: 'Provider Callbacks',
      permissionCheck: 'canViewProviderCallbacks',
    },
  },
  {
    path: '/tools/bulk_edit',
    name: '#bulkEdit',
    component: () => import('@/pages/Tools/BulkEdit/BulkEdit.vue'),
    meta: {
      title: 'Bulk Edit',
      permissionCheck: 'canEditBulkSubtasks',
    },
  },
  {
    path: '/tools/humana-eligibility-check',
    name: '#HumanaEligibilityCheck',
    component: () =>
      import('@/pages/Tools/HumanaEligibilityCheck/HumanaEligibilityCheck.vue'),
    meta: {
      title: 'Humana Eligibility Check',
      permissionCheck: null,
    },
  },
  {
    path: '/tools/form-response',
    name: '#FormResponse',
    component: () => import('@/pages/Tools/FormResponse/FormResponse.vue'),
    meta: {
      title: 'Form Response',
      permissionCheck: 'canViewPageFormResponses',
    },
  },
  {
    path: '/tools/search-form-responses',
    name: '#FormResponses',
    component: () =>
      import('@/pages/Tools/FormResponse/FormResponses/FormResponses.vue'),
    meta: {
      title: 'Search Form Responses',
      permissionCheck: 'canViewPageFormResponses',
    },
  },
  {
    path: '/tools/campaigns',
    name: '#bulkCampaigns',
    component: () =>
      import('@/legacy/components/admin/campaigns/CampaignsTable.vue'),
    meta: {
      title: 'Bulk Campaigns',
      permissionCheck: 'canSendBulkTexts',
    },
  },
  {
    path: '/tools/cohorts',
    name: '#cohorts',
    component: () => import('@/pages/Admin/CohortBuilder/CohortBuilder.vue'),
    meta: {
      title: 'Create Cohort',
      permissionCheck: 'canCreateCohorts',
    },
  },
  {
    path: '/sandbox',
    name: '#sandbox',
    component: () => import('@/legacy/pages/debug/AdminDebug.vue'),
    meta: {
      title: 'Sandbox',
      permissionCheck: 'canViewPageNashDebugSandbox',
    },
  },
  {
    path: '/debug',
    name: '#debug',
    component: () =>
      import('@/pages/Basic/DebugInformation/DebugInformation.vue'),
    meta: {
      title: 'Debug',
      permissionCheck: null,
    },
  },
  sopLibraryRoute(),
  sopLibraryDocumentRoute(),
]
